var SMOOTH_SCROLL_SPEED = 700;
var siteHeaderHeight = $('.site-header').height();
var menuList = $('.menu-list');

var scrollTo = function () {
  menuList.on('click', function (e) {
    var id = $(e.target).attr('href');

    if (!id) { return }

    $('html, body').stop().animate({
      scrollTop: $(id).offset().top - siteHeaderHeight
    }, SMOOTH_SCROLL_SPEED);

    e.preventDefault();
  });
}

module.exports = {scrollTo}
